import { render } from "./AccountsView.vue?vue&type=template&id=3b7a07ca"
import script from "./AccountsView.vue?vue&type=script&lang=js"
export * from "./AccountsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__